// extracted by mini-css-extract-plugin
export default {"panel":"Panel_panel__7k6ZX","info":"Panel_info__145vU","btns":"Panel_btns__hhIR+","button":"Panel_button__r5Qbx"};